import {TokenStorageService} from '@em/auth/data-access';
import {JwtOptions} from './jwt-options';

export function JwtOptionsFactory(tokenStorage: TokenStorageService) {
  return new JwtOptions(tokenStorage);
}
